import { SEND_MESSAGE, CLOSE_MESSAGE } from './../actions/MessageAction';

const defaultState = {
    open   : false,
    message: '',
    timeout: 4000
};

const message = (state = defaultState, action) => {
    switch(action.type)
    {
        case SEND_MESSAGE:
            return {...state,
                message: action.message,
                open   : true,
                timeout: action.timeout
            };
        case CLOSE_MESSAGE:
            return {...state,
                open   : false,
                message: ''
            };
        default:
            return state;
    }
};

export default message;


// WEBPACK FOOTER //
// ./src/reducers/MessageReducer.js